import { type FC, type ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: FC<{ children: ReactNode; }> = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [ location.pathname ]);

    return <>{children}</>;
};

export default ScrollToTop;
